import type { RouteRecordRaw } from 'vue-router';
import { SPIN_CAMPAIGN_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const createSpinCampaignRoutes: RouteRecordRaw = {
  path: '/spin-campaign/create',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      path: '',
      name: SPIN_CAMPAIGN_ROUTE_NAME.SPIN_CAMPAIGN_CREATE,
      component: () => import('./CreateSpinCampaign.vue'),
    },
  ],
};
